var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatRatingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1837 25.1207C18.9125 25.1207 24.3673 19.6659 24.3673 12.9371C24.3673 6.20823 18.9125 0.753418 12.1837 0.753418C5.45481 0.753418 0 6.20823 0 12.9371C0 19.6659 5.45481 25.1207 12.1837 25.1207Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51433 13.1805C8.6358 13.1805 9.54494 12.2714 9.54494 11.1499C9.54494 10.0284 8.6358 9.11931 7.51433 9.11931C6.39285 9.11931 5.48372 10.0284 5.48372 11.1499C5.48372 12.2714 6.39285 13.1805 7.51433 13.1805Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8547 13.1805C17.9761 13.1805 18.8853 12.2714 18.8853 11.1499C18.8853 10.0284 17.9761 9.11931 16.8547 9.11931C15.7332 9.11931 14.8241 10.0284 14.8241 11.1499C14.8241 12.2714 15.7332 13.1805 16.8547 13.1805Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.988 19.4347H9.38348C8.77429 19.4347 8.77429 17.8102 9.38348 17.8102H14.9473C15.5971 17.8102 15.5971 19.4347 14.988 19.4347Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatRatingIcon);
export default __webpack_public_path__ + "static/media/sat-rating-icon.f06b17e74c45ab7c175ace5ae6cfbe1b.svg";
export { ForwardRef as ReactComponent };